module.exports = __webpack_public_path__ + "static/img/helh322.db9df63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh322.png
// module id = 2AKQ
// module chunks = 5